// Returns the topmost same-origin ancestor window.
// Standalone app → window.top. Cross-origin embed → the topmost window
// still accessible without triggering SecurityError. Returns null in non-browser.
export const sameOriginTop = () => {
  if (typeof window === 'undefined') return null
  let w = window
  while (w.parent && w.parent !== w) {
    try {
      void w.parent.document
      w = w.parent
    } catch {
      break
    }
  }
  return w
}
